import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR, SIDE_NAV_DARK } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Network-Scanner';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const PANEL_PREFIX_PATH = '/panel';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const AUTHENTICATED_PANEL_ENTRY = `${PANEL_PREFIX_PATH}/dashboard`;
export const UNAUTHENTICATED_ENTRY = '/login'

const theme = JSON.parse(localStorage.getItem("theme"));

export const THEME_CONFIG = {
	navCollapsed: theme?.navCollapsed || true,
	sideNavTheme: theme?.sideNavTheme || SIDE_NAV_LIGHT,
	locale: theme?.locale || 'en',
	navType: theme?.navType || NAV_TYPE_SIDE,
	topNavColor: theme?.topNavColor || '#3e82f7',
	headerNavColor: theme?.headerNavColor || '#3e82f7',
	mobileNav: theme?.mobileNav || false,
	currentTheme: theme?.currentTheme || 'light',
	direction: theme?.direction || DIR_LTR,
	blankLayout: theme?.blankLayout || false,
	loading: theme?.loading || false
};
